<template>
  <a-modal class="modal-content" :width="'50%'" v-model="updateUser" :title="$t('org.editUserInfo')" :maskClosable="maskClosable"
    @ok="handleOk">

    <div style="padding:20px;">
      <a-card>
        <a-form :form="userForm">
          <a-form-item :label="$t('org.userInfo')" v-bind="formItemLayout">
            <a-input size="small" v-model="user.username" disabled></a-input>
          </a-form-item>


          <!-- <a-form-item :label="$t('org.role')" v-bind="formItemLayout">
            <a-input size="small" v-model="roleName" disabled></a-input>
          </a-form-item> -->

          <a-form-item :label="$t('org.nickName')" v-bind="formItemLayout">
            <a-input size="small" v-model="user.nickname" v-decorator="['nickname',{ rules: [
                        { required: true, message: $t('org.validateTip.nickNameRequired') },
                        { max:20, min: 1, message: $t('org.validateTip.nickNameRule')},
                        { validator: hasSpecialChar}
                        ]}]"></a-input>
          </a-form-item>

          <a-form-item :label="$t('org.phone')" v-bind="formItemLayout">
            <a-input size="small" v-model="user.phone"
              v-decorator="['userPhone',{ rules: [{ pattern: /^1[34578]\d{9}$/, message: $t('org.validateTip.phoneRule')}] }]"></a-input>
          </a-form-item>

          <a-form-item :label="$t('org.autoRefresh')" v-bind="formItemLayout">
            <a-switch @change="onAutoRefreshSwitched" :defaultChecked="autoRefresh" :checked="autoRefresh" size="small"></a-switch>
            <!-- <a-input size="small" v-model="user.autoRefresh"
              v-decorator="['userPhone',{ rules: [{ pattern: /^1[34578]\d{9}$/, message: '请输入正确的电话号码'}] }]"></a-input> -->
          </a-form-item>

          <a-form-item :label="$t('org.avatar')" v-bind="formItemLayout">
            <a-avatar size="large" v-if="imageUrl" :src="imageUrl"></a-avatar>
            <span v-else>---</span>
            <a-upload :action="imageUploadUrl + '?type=user'" :format="['jpg','png','jpeg','bmp']"
              :beforeUpload="beforeUpload" :showUploadList="false" @change="handleChange" :headers="token">
              <a-button size="small" type="primary" style="margin-left:15px">
                <a-icon type="upload" style="padding-right:4px" />
                {{$t('global.upload')}}
              </a-button>
            </a-upload>

            <a-button size="small" style="margin-left:15px" @click="deleteLogo" v-if="imageUrl">
              <a-icon type="delete" style="padding-right:4px" />
              {{$t('global.delete')}}
            </a-button>
          </a-form-item>

          <a-alert style="left:25%;width:70%" :message="$t('global.tips') + ':'" type="info" showIcon>
            <p slot="description">
              1：{{$t('global.imgTypeTip')}}
              <br />
              2：{{$t('global.imgSizeTip')}}
            </p>
          </a-alert>
        </a-form>
      </a-card>
    </div>
  </a-modal>
</template>

<script>
  import config from '@/config'
  import {hasSpecialChar} from '@/utils/formFunctions'
  // import {mapGetters} from 'vuex'
  export default {
    name: 'ZUpdateOrgUser',
    data() {
      return {
        showEditPassword: false,
        autoRefresh: '',
        updateUser: false,
        userForm: null,
        user: {},
        orgId: null,
        maskClosable: false,
        imageUploadUrl: config.api.file_upload_url,
        token: {},
        roleName: null,
        imageUrl: '',
        formItemLayout: {
          labelCol: {
            xs: {
              span: 18
            },
            sm: {
              span: 6
            },
          },
          wrapperCol: {
            xs: {
              span: 24
            },
            sm: {
              span: 16
            },
          }
        }
      }
    },
    methods: {
      hasSpecialChar,
      onAutoRefreshSwitched (checked) {
        console.log(checked)
        this.autoRefresh = checked
        console.log(this.autoRefresh)
      },
      deleteLogo() {
        this.imageUrl = ''
      },
      // 验证密码
      oldPasswordChanged(ev) {
        console.log(ev.target.value)
        // 这里需要发送请求验证密码是否正确，如果正确才允许修改密码
        // http
      },
      changeShowStatus() {
        this.showEditPassword = !this.showEditPassword
      },
      beforeUpload(file) {
        if (file.type.indexOf('image/') == -1) {
          this.$notification["warning"]({
            message: this.$t('global.tips'),
            description: this.$t('global.imgTypeTip'),
          });
          return false
        }
        let fileSize = file.size
        if (fileSize >= 1048576) {
          this.$notification["warning"]({
            message: this.$t('global.tips'),
            description: this.$t('global.imgSizeTip'),
          });
          return false
        }
        return true
      },
      handleChange(info) {
        if (info.file.status === 'done' && info.file.response.code == 0) {
          this.imageUrl = info.file.response.result.imageUrl
        }
      },
      handleOk() {
        this.userForm.validateFieldsAndScroll((err) => {
          if (!err) {
            let user = {}
            user.id = this.user.id
            user.imageUrl = this.imageUrl
            user.phone = this.user.phone
            user.nickname = this.user.nickname
            user.autoRefresh = this.autoRefresh
            // console.log(user)
            this.$http.put(config.api.user_update_url, user).then((response) => {
              if (response.code == 0) {
                this.updateUser = false
                // this.$message.success('修改成功')
                this.$notification.success({
                  message: this.$t('global.commitSuccess')
                })
                this.$emit("updateSuccess", this.orgId)
              } else {
                // this.$message.error(response.desc)
                this.$notification.error({
                  message: response.desc
                })
              }
            })
          }
        })
      },
      showModel(user, orgId) {
        // console.log(user)
        this.updateUser = true
        this.user = user
        this.imageUrl = user.imageUrl == null ? '' : user.imageUrl
        this.orgId = orgId
        this.autoRefresh = this.user.autoRefresh || false
        this.userForm = this.$form.createForm(this)
        this.roleName = this.user.roles[0].description
        this.userMessageNum = user.phone
        this.$nextTick().then(() => {
          this.userForm.setFieldsValue({
            userPhone: user.phone,
            nickname: user.nickname
          })
        })
      }
    },
    created() {
      this.token = {
        Authorization: 'Bearer ' + this.$store.getters.token
      }
    }
  }
</script>